import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from '@hydra/common/components';
import { Criterium, CriteriumTable } from '@hydra/common/criterium';

const shownHeadings = ['<H1>', '<H2>', '<H3>', '<H4>', '<H5>'];
const headingsList = ['h1', 'h2', 'h3', 'h4', 'h5'];
const tableClasses = {
  head: ['center', 'center', 'center', 'center', 'center'],
  body: ['center', 'center', 'center', 'center', 'center']
};

const getAdviceVariables = ({ url, data }) => {
  const getCount = h => (data[h] || []).length.toString();

  return {
    domain: url,
    h1Count: getCount('h1'),
    h2Count: getCount('h2'),
    h3Count: getCount('h3'),
    h4Count: getCount('h4'),
    h5Count: getCount('h5')
  };
};

export const Headings = ({ criterium }) => {
  const { data, url } = criterium;

  const counts = headingsList.map(heading => (data[heading] || []).length);
  const teaser = headingsList
    .reduce((titles, heading) => {
      const headingTitles = data[heading] || [];
      return titles.concat(headingTitles.map(title => ({ title, heading })));
    }, [])
    .map(({ title, heading }) => ([
      <strong key='heading'>{`<${heading.toUpperCase()}>`}</strong>,
      title
    ]));

  const content = Object.keys(data).length > 0
    ? (
      <>
        <CriteriumTable
          head={shownHeadings}
          rows={[counts]}
          fixedColumns={[20, 20, 20, 20, 20]}
          classNames={tableClasses}
          thinHead
          nowrap
        />
        <CriteriumTable
          head={['']}
          rows={teaser}
          fixedColumns={[15, 85]}
          thinHead
          striped
          nowrap
        />
      </>
      )
    : <Translate content='headings_ko' />;

  return (
    <Criterium
      criterium={criterium}
      variables={getAdviceVariables({ url, data })}
    >
      {content}
    </Criterium>
  );
};

Headings.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      h1: PropTypes.array,
      h2: PropTypes.array,
      h3: PropTypes.array,
      h4: PropTypes.array,
      h5: PropTypes.array
    })
  })
};

export default React.memo(Headings);
